import { AlertCircle } from 'lucide-react';

interface EmptyStateProps {
    title: string;
    description: string;
}

export function EmptyState({ title, description }: EmptyStateProps) {
    return (
        <div className="rounded-lg bg-gray-50 border border-gray-200 p-8 md:p-12 text-center">
            <div className="flex justify-center mb-4">
                <div className="p-3 bg-gray-100 rounded-full">
                    <AlertCircle className="h-6 w-6 md:h-8 md:w-8 text-gray-400" />
                </div>
            </div>
            <h3 className="text-base md:text-lg font-semibold text-gray-900 mb-2">{title}</h3>
            <p className="text-xs md:text-sm text-gray-600">{description}</p>
        </div>
    );
}